import { configureStore } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { authTokenMiddleware } from './middleware/authTokenMiddleware';
import { stepperReducer } from './stepper/slices/stepperSlice';
import { userReducer } from './user/slices/userSlice';

const stepperPersistConfig = {
  key: 'stepper',
  storage,
};

const persistedStepperReducer = persistReducer(
  stepperPersistConfig,
  stepperReducer,
);

// Configure the Redux store with reducers and middleware
export const store = configureStore({
  reducer: {
    stepper: persistedStepperReducer,
    user: userReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(authTokenMiddleware as Middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
